module.exports = __webpack_public_path__ + "img/banner03_info_life.182e6c98.svg";